import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { useGlobalContext, useRepository } from '@context';
import { IFeatureFlags } from '@common/interfaces';

const useFeatureFlags = (): IFeatureFlags => {
  const { accountRepository } = useRepository();

  const { featureFlags, setFeatureFlags } = useGlobalContext();

  const { data } = useQuery('get-feature-flags', () => accountRepository.getFeatureFlags(), {
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (data) {
      setFeatureFlags(data);
    }
  }, [data, setFeatureFlags]);

  return featureFlags;
};

export default useFeatureFlags;
